import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'
import moment from 'moment-timezone'
import queryString from 'query-string'
import {saveAs} from "file-saver";
import config from 'config'

const csvDownloadOptions = {
  credentials: 'include',
  method: 'GET',
  headers: {
    'Content-Type': 'text/csv'
  },
  responseType: 'blob'
}

const getOptionsWithUser = {
  credentials: 'include',
    method: 'GET'
}

function getWalkInInterestQuery(filter, states=[], alwaysIncludeStates = ['missed follow up', 'today follow up'], searchAfter = undefined) {
  let filterData =  typeof filter === 'string' ? JSON.parse(filter) : filter.toJSON()
  let {startDate, endDate, storeNames,leadOwners,leadSources} = filterData
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam,
    leadOwners: leadOwners,
    leadSources:leadSources,
    // alwaysIncludeStates: alwaysIncludeStates,
    states:states,
    searchAfter: searchAfter
  }, {arrayFormat: 'bracket'})
  return query;
}

function getWalkInInterestReportQuery(filter) {
  let {startDate, endDate, storeNames, brand, brandBusiness, download} = filter.toJSON();
  let startDateParam = moment(startDate).format('YYYY-MM-DD')
  let endDateParam = moment(endDate).format('YYYY-MM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam,
    brandName: _.lowerCase(brand.name),
    businessUnitName: _.lowerCase(brandBusiness.name),
    download: download
  }, {arrayFormat: 'bracket'})
  return query;
}

function  getWalkInInterests(filter) {
  let query = getWalkInInterestQuery(filter);
  return fetch(`${casaApiUrl}/users/walk-in-interests/filter?${query}`, getOptionsWithUser).then(res => res.json())
}

function getWalkInInterestsSummary(filter) {
  let query = getWalkInInterestQuery(filter);
  return fetch(`${casaApiUrl}/users/walk-in-interests/summary/filter?${query}`, getOptionsWithUser).then(res => res.json())
}

function getWalkInInterestsByRefs (refs) {
  return fetch(`${casaApiUrl}/users/walk-in-interests/raw/by?${refs}`, getOptionsWithUser).then(res => res.json())
}

function getWalkInInterestForm () {
  return fetch(`${casaApiUrl}/users/form-fields/walkInInterestForm`, getOptionsWithUser).then(res => res.json())
}

function getEndlessAisleForm () {
  return fetch(`${casaApiUrl}/users/form-fields/endlessAisleForm`, getOptionsWithUser).then(res => res.json())
}

function walkInInterestCategoryWise (filter, options) {
  const query  = getWalkInInterestReportQuery(filter);
  return fetch(`${casaApiUrl}/users/walk-in-interests/category/reports?${query}`, options)
}
function getWalkInInterestCategoryWise (filter) {
  return walkInInterestCategoryWise(filter, getOptionsWithUser).then(res => res.json())
}
function downloadWalkInInterestCategoryWise (filter, name= 'Category-Wise') {
  return walkInInterestCategoryWise(filter, csvDownloadOptions)
    .then(res => res.blob())
    .then(blob => saveAs(blob, `${name}.csv`))
    .catch(() => {})
}

function walkInInterestStoreWise (filter) {
  const query  = getWalkInInterestReportQuery(filter);
  return fetch(`${casaApiUrl}/users/walk-in-interests/store/reports?${query}`, getOptionsWithUser)
}
function getWalkInInterestStoreWise (filter) {
  return walkInInterestStoreWise(filter, getOptionsWithUser).then(res => res.json())
}
function downloadWalkInInterestStoreWise (filter, name = "Store-Wise") {
  return walkInInterestStoreWise(filter, csvDownloadOptions)
    .then(res => res.blob())
    .then(blob => saveAs(blob, `${name}.csv`))
    .catch(() => {})
}


function walkInInterestMissedFollowUp (filter, options) {
  const query  = getWalkInInterestReportQuery(filter);
  return fetch(`${casaApiUrl}/users/walk-in-interests/missed-follow-ups/reports?${query}`, options)
}
function getWalkInInterestMissedFollowUp (filter) {
  return walkInInterestMissedFollowUp(filter, getOptionsWithUser).then(res => res.json())
}
function downloadWalkInInterestMissedFollowUp (filter, name= 'Missed-Follow-Ups') {
  return walkInInterestMissedFollowUp(filter, csvDownloadOptions)
    .then(res => res.blob())
    .then(blob => saveAs(blob, `${name}.csv`))
    .catch(() => {})
}

function walkInInterestLeadConversion (filter, options) {
  const query  = getWalkInInterestReportQuery(filter);
  return fetch(`${casaApiUrl}/users/walk-in-interests/lead-conversion/reports?${query}`, options)
}
function getWalkInInterestLeadConversion (filter) {
  return walkInInterestLeadConversion(filter, getOptionsWithUser).then(res => res.json())
}
function downloadWalkInInterestLeadConversion(filter, name='Lead-Conversion') {
  return walkInInterestLeadConversion(filter, csvDownloadOptions)
    .then(res => res.blob())
    .then(blob => saveAs(blob, `${name}.csv`))
    .catch(() => {})
}

function getLeadPriceMaster (businessUnitId) {
  return fetch(`${casaApiUrl}/users/casa-product-master/leads-product-price/${businessUnitId}`, getOptionsWithUser).then(res => res.json())
}

function getSiteDetails(mobile) {
  return fetch(`${casaApiUrl}/users/site-opportunity/beat/list/${mobile}`, getOptionsWithUser).then(res =>  res.json())
}

function getWalkinSources(){
  return fetch(`${casaApiUrl}/users/walk-in-interests/lead-sources`, getOptionsWithUser).then(res =>  res.json())
}

function getLeadsByLane(filter,states, alwaysIncludeStates, searchAfter= undefined){
  console.log("before filter query ****************************",filter)
  let query = getWalkInInterestQuery(filter,states, alwaysIncludeStates,searchAfter);
  return fetch(`${casaApiUrl}/users/walk-in-interests/filter-by-lane?${query}`, getOptionsWithUser).then(res => res.json())
}

function getCustomDropdowns() {
  return fetch(`${casaApiUrl}/users/lms-dropdowns`, getOptionsWithUser).then(res => res.json())
}

export default {
  getWalkInInterestsSummary,
  getWalkInInterests,
  getWalkInInterestsByRefs,
  getWalkInInterestForm,
  getEndlessAisleForm,
  getWalkInInterestCategoryWise,
  getWalkInInterestStoreWise,
  getWalkInInterestMissedFollowUp,
  getWalkInInterestLeadConversion,
  downloadWalkInInterestMissedFollowUp,
  downloadWalkInInterestCategoryWise,
  downloadWalkInInterestStoreWise,
  downloadWalkInInterestLeadConversion,
  csvDownloadOptions,
  getLeadPriceMaster,
  getSiteDetails,
  getWalkinSources,
  getLeadsByLane,
  getCustomDropdowns
}




// WEBPACK FOOTER //
// ./src/services/walk-in-interests-service.js